import * as React from "react";
import { styled, MenuItem, Select, Stack, Typography, Box } from "@mui/material";

import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import ConfigContentRecaps from "../../Config/ConfigContentRecaps/config-content-row-recap";
import AssetThumbnail from "../../Misc/AssetThumbnail";
import { ObjectType } from "../../../Core/Api/Types/object-type";
import { useTranslation } from "react-i18next";

interface MissingAssetSubbarProps {}

const MissingAssetSubbar: React.FC<MissingAssetSubbarProps> = (props) => {
  const { t } = useTranslation();
  return (
    <Stack width="100%" direction="row" alignItems="center" justifyContent="space-between" spacing={2}>
      <Stack direction="row" flex={1} alignItems="center" spacing={3}>
        <Stack flex={1}>
          <Typography fontWeight={500} mb={0.5}>
            {t("common:selfBroadcastedFileToOcs")}
          </Typography>
          <Box>
            <ConfigContentRecaps
              setting="4K HDR 24 FPS"
              voice="FR 15 Dolby"
              subtitles="FR FR (SDH) .srt"
              color="text.tier"
              variant="body2"
            />
          </Box>
        </Stack>
        {/* TODO : Change, self-broadcasted doesn't exist on AssetType enum
        <AssetThumbnail type="self-broadcasted" /> */}
      </Stack>
      <StyledDivider>
        <img src="/static/images/arrow-divider.svg" alt="" />
      </StyledDivider>
      <Stack direction="row" flex={1} alignItems="center" spacing={3}>
        <Stack flex={1}>
          <Typography fontWeight={500} mb={0.5}>
            {`${t("common:totalRecall")} - ${t("common:bonus")} - ${t("common:subtitles")}`}
          </Typography>
          <Box>
            <Typography variant="body2" color="text.tier" sx={(theme) => ({ ...theme.helpers(theme).clampedText })}>
              DREAMERS WITHIN THE DREAM : LA GENÈSE DE TOTAL RECALL / Mezz - French - Full Subtitles - STL - Open
              DREAMERS WITHIN THE DREAM : LA GENÈSE DE TOTAL RECALL / Mezz - French - Full Subtitles - STL - Open
            </Typography>
          </Box>
        </Stack>
        <AssetThumbnail type={ObjectType.Subtitle} />
      </Stack>
      <StyledDivider>
        <img src="/static/images/arrow-divider.svg" alt="" />
      </StyledDivider>
      <Box flex={1}>
        <Select
          displayEmpty
          value=""
          IconComponent={ExpandMoreRoundedIcon}
          sx={{ width: "100%" }}
          MenuProps={{ PaperProps: { sx: { maxHeight: 600 } } }}
        >
          <MenuItem value="">{t("menu:item.pickUpDeal")}</MenuItem>
          <MenuItem value="title">{t("common:title")}</MenuItem>
          <MenuItem value="quality">{t("menu:item.bestQuality")}</MenuItem>
        </Select>
      </Box>
    </Stack>
  );
};

const StyledDivider = styled("figure")(({ theme }) => ({
  marginLeft: theme.spacing(4),
  marginRight: "auto",
  alignSelf: "stretch",
  img: {
    ...theme.helpers(theme).fullImage,
    width: "auto",
  },
}));

export default MissingAssetSubbar;
